import FaceModal from "./modules/FaceModal";
import FaceAPI from "./modules/FaceAPI";

const { ENV, BASE_URI } = window.WP_VARS;

const modalEl = document.querySelector(".face-modal");

const api = new FaceAPI(ENV === "local" ? "http://kidworks.local" : BASE_URI);

const faceModal = new FaceModal({ modalEl });

const handleFaceClick = (faceEl) => {
  faceModal.open();
  const faceID = faceEl.dataset.postId;
  api.getFaceById(faceID).then((face) => {
    faceModal.hydrate(face);
    faceModal.show();
  });
};

// collect all faces
const faceEls = document.querySelectorAll(".js-face");
faceEls.forEach((f) =>
  f.addEventListener("click", (e) => handleFaceClick(f, e))
);
